import script from "./Copy.vue?vue&type=script&setup=true&lang=js"
export * from "./Copy.vue?vue&type=script&setup=true&lang=js"

import "./Copy.vue?vue&type=style&index=0&id=2faa7a6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2faa7a6a"]])

export default __exports__